import _curry from "ramda/es/curry";
import _lt from "ramda/es/lt";
import _view from "ramda/es/view";
import _pipe from "ramda/es/pipe";

var lensLt = function (lens, value, obj) {
  return _pipe(_view(lens), _lt(value))(obj);
};

export default _curry(lensLt);